import { axiosAuth } from "./axiosInstances";

// KHAN-144: /translate/googleTranslate/ dejo de aceptar peticiones anonimas
// (antes tenia AllowAny, asi que cualquiera podia quemar cuota del servicio
// externo de traduccion). Esta llamada usaba axiosWithoutAuth, que no adjunta
// el JWT, asi que ahora tiene que ir por axiosAuth o el backend responde 403.
//
// KHAN-261: backend renombrado apps.TranslateApp -> apps.translate y el path
// paso de /translate/googleTranslate/ (camelCase) a /translate/text/ (accion
// de dominio, kebab-case). Se llama con la barra final incluida a proposito:
// el patron registrado en apps/translate/urls.py ahora la exige, y
// APPEND_SLASH solo redirige peticiones SIN barra hacia la version con
// barra (nunca al reves), y ese redirect es fragil para POST (algunos
// clientes HTTP no lo siguen y pierden el body). Solo cambia la URL interna;
// el nombre exportado y la firma de esta funcion (text, targetLanguage) se
// mantienen para no romper a TextSelectorMenu.jsx, el unico consumidor.
export async function google_translate(text, targetLanguage) {
  return await axiosAuth().post('/translate/text/', { text: text, target_language: targetLanguage })
}